import type { ReviewsQuery } from '#graphql-operations'

export const useReviewsQuery = defineQuery(() => {
  const { locale } = useI18n()

  const { state, ...rest } = useQuery({
    key: () => ['reviews', { languageCode: locale.value }],
    enabled: import.meta.client,
    query: async () => {
      const result = await useGraphqlQuery(`reviews`, {
        options: {
          take: 3,
          skip: 0,
        },
      }) as { data: ReviewsQuery }

      return result.data?.productReviews
    },
  })

  return {
    ...rest,
    reviews: state,
  }
})
